import { render, staticRenderFns } from "./PeakLoginRedirectView.vue?vue&type=template&id=620f833e&"
import script from "./PeakLoginRedirectView.vue?vue&type=script&lang=js&"
export * from "./PeakLoginRedirectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports